module.exports = __webpack_public_path__ + "static/screenshot-4-46934fc09ebf4c259006017f1d2b64b6.png";